"use strict";
'use es6'; // NO TRANFORM

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listsindex = exports.listdetail = exports.listcreate = exports.visitsindex = exports.ticketsindex = exports.ticketsboard = exports.ticketprofile = exports.tasksindex = exports.tasksboard = exports.redirectto = exports.tasks = exports.quotelanding = exports.queuetask = exports.propertyhistory = exports.dealsindex = exports.dealsboard = exports.dealprofile = exports.contactworkflows = exports.contactsindex = exports.contactsample = exports.contactprofile = exports.companyprofile = exports.companiesindex = exports.objectassociator = exports.objectcreator = exports.deals = exports.dealline = exports.contactvisual = exports.contactsales = exports.companysales = exports.twilio = void 0;
var twilio = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view twilio'
  }
}; // NO TRANFORM

exports.twilio = twilio;
var companysales = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view record'
  }
}; // NO TRANSFORM

exports.companysales = companysales;
var contactsales = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view record'
  }
}; // NO TRANSFORM

exports.contactsales = contactsales;
var contactvisual = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view contact visual'
  }
}; // NO TRANSFORM

exports.contactvisual = contactvisual;
var dealline = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index'
  }
}; // NO TRANSFORM

exports.dealline = dealline;
var deals = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index'
  }
}; // NO TRANSFORM

exports.deals = deals;
var objectcreator = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view object creator'
  }
}; // NO TRANSFORM

exports.objectcreator = objectcreator;
var objectassociator = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view object associator'
  }
};
exports.objectassociator = objectassociator;
var companiesindex = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index'
  }
};
exports.companiesindex = companiesindex;
var companyprofile = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view record'
  }
};
exports.companyprofile = companyprofile;
var contactprofile = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view record'
  }
};
exports.contactprofile = contactprofile;
var contactsample = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view sample record'
  }
};
exports.contactsample = contactsample;
var contactsindex = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index'
  }
};
exports.contactsindex = contactsindex;
var contactworkflows = {
  key: 'view-recordinteraction',
  properties: {
    action: 'clicked to view workflows'
  }
};
exports.contactworkflows = contactworkflows;
var dealprofile = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view record'
  }
};
exports.dealprofile = dealprofile;
var dealsboard = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index',
    type: 'board view'
  }
};
exports.dealsboard = dealsboard;
var dealsindex = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index',
    type: 'list view'
  }
};
exports.dealsindex = dealsindex;
var propertyhistory = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view property history'
  }
}; // NO TRANSFORM

exports.propertyhistory = propertyhistory;
var queuetask = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view queue task'
  }
}; // NO TRANSFORM

exports.queuetask = queuetask;
var quotelanding = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view quote landing'
  }
}; // NO TRANSFORM

exports.quotelanding = quotelanding;
var tasks = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index',
    type: 'list view'
  }
};
exports.tasks = tasks;
var redirectto = {
  key: 'view-indexinteraction',
  properties: {
    action: 'redirect to'
  }
};
exports.redirectto = redirectto;
var tasksboard = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index',
    type: 'board view'
  }
};
exports.tasksboard = tasksboard;
var tasksindex = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index',
    type: 'list view'
  }
};
exports.tasksindex = tasksindex;
var ticketprofile = {
  key: 'view-recordinteraction',
  properties: {
    action: 'view record'
  }
};
exports.ticketprofile = ticketprofile;
var ticketsboard = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index',
    type: 'board view'
  }
};
exports.ticketsboard = ticketsboard;
var ticketsindex = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view index',
    type: 'list view'
  }
};
exports.ticketsindex = ticketsindex;
var visitsindex = {
  key: 'view-indexinteraction',
  properties: {
    action: 'view',
    type: 'list view'
  }
};
exports.visitsindex = visitsindex;
var listcreate = {
  key: 'view-listcreate',
  properties: {
    action: 'view',
    type: 'list view'
  }
};
exports.listcreate = listcreate;
var listdetail = {
  key: 'view-listdetail',
  properties: {
    action: 'view',
    type: 'list view'
  }
};
exports.listdetail = listdetail;
var listsindex = {
  key: 'view-listsindex',
  properties: {
    action: 'view',
    type: 'list view'
  }
};
exports.listsindex = listsindex;